import links from "@/links/links";

export default {
  actions: {
    FETCH(buildingId) {
      return this.get(links.BUILDING_MAJORITIES_BY_BUILDING(buildingId), {
        dataKey: "hydra:member",
      });
    },
    POST(item) {
      return this.post(links.BUILDING_MAJORITIES(), item);
    },
    ADD_BULK_MAJORITIES(item) {
      return this.post(links.BUILDING_MAJORITIES_BULK_MAJORITIES(), item);
    },
    DELETE(itemId) {
      return this.delete(links.BUILDING_MAJORITIES() + "/" + itemId, {
        delete: itemId,
      });
    },
  },
};
